import { useEffect } from 'react'
import { DEVICE_USER_KEY, unbindCommunicationPush } from './device-push'
import { useRegisterCommunicationPushSubscriptionMutation } from '@/graphql/queries/communicationNotificationsQuery.gql.generated'

export function useDeviceReconciliation(
  userId: string | undefined,
  workspaceId: string | null | undefined,
  canRead: boolean,
) {
  const [register] = useRegisterCommunicationPushSubscriptionMutation()
  useEffect(() => {
    void reconcileDevice(userId, workspaceId, canRead, register).catch(() => {})
  }, [userId, workspaceId, canRead, register])
}

async function reconcileDevice(
  userId: string | undefined,
  workspaceId: string | null | undefined,
  canRead: boolean,
  register: ReturnType<
    typeof useRegisterCommunicationPushSubscriptionMutation
  >[0],
) {
  if (!userId || !('serviceWorker' in navigator)) return
  const subscription = await ownedSubscription(userId)
  if (!subscription || !workspaceId || !canRead) return
  const json = subscription.toJSON()
  if (!json.keys) return
  await register({
    variables: {
      input: {
        workspaceId,
        endpoint: subscription.endpoint,
        p256dh: json.keys.p256dh,
        auth: json.keys.auth,
      },
    },
  })
}

async function ownedSubscription(userId: string) {
  const owner = localStorage.getItem(DEVICE_USER_KEY)
  if (owner && owner !== userId) {
    await unbindCommunicationPush()

    return
  }
  const registration = await navigator.serviceWorker.getRegistration()
  const subscription = await registration?.pushManager.getSubscription()
  if (!subscription || owner !== userId) return
  if (Notification.permission !== 'granted') {
    await unbindCommunicationPush()

    return
  }

  return subscription
}
